// Lecturas que muestran existencias: se releen cuando la venta suelta lo que tenía apartado.
import type { QueryClient } from '@tanstack/react-query';
import { INVENTORY_QUERY_KEY } from '@/domains/retail/admin/inventario/api/useInventarioLens';
import { PORTAL_CATALOG_KEY } from '@/domains/sales/portal/catalog/api/usePortalCatalog';

/** Prefijos de inventario y catálogo: el de la tienda, el del portal y el de Admin. */
export const STOCK_QUERY_PREFIXES = [
    ['wizard', 'catalog'],
    PORTAL_CATALOG_KEY,
    INVENTORY_QUERY_KEY,
    ['retail', 'products'],
] as const;

/** Invalida toda lectura de existencias. */
export async function invalidateStockQueries(qc: QueryClient): Promise<void> {
    await Promise.all(
        STOCK_QUERY_PREFIXES.map((queryKey) => qc.invalidateQueries({ queryKey: [...queryKey] })),
    );
}
